import React from "react";

const styles = {
  footer: {
    background: "#102542",
    color: "#fff",
    marginTop: "40px",
  },

  footerContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
    gap: "30px",
    padding: "40px",
  },

  footerSection: {
    lineHeight: "1.8",
  },

  heading: {
    color: "#ff8a00",
    marginBottom: "15px",
  },

  link: {
    display: "block",
    color: "#fff",
    textDecoration: "none",
    margin: "8px 0",
  },

  socialIcons: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  footerBottom: {
    textAlign: "center",
    padding: "15px",
    borderTop: "1px solid rgba(255,255,255,0.2)",
    background: "#0b1c33",
    fontSize: "14px",
  },
};

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.footerContainer}>

        {/* About */}
        <div style={styles.footerSection}>
          <h3 style={styles.heading}>ग्रामपंचायत भालेवाडी</h3>
          <p>पंचायत समिती कारंजा (घा), जिल्हा परिषद वर्धा</p>
          <p>महाराष्ट्रातील एकमेव ग्रामपंचायत उपक्रम</p>
        </div>

        {/* Contact */}
        <div style={styles.footerSection}>
          <h3 style={styles.heading}>संपर्क</h3>
          <p>📞 9764572954</p>
          <p>📧 gpbhalewadi@gmail.com</p>
          <p>📍 भालेवाडी, वर्धा, महाराष्ट्र</p>
        </div>

        {/* Social Media */}
        <div style={styles.footerSection}>
          <h3 style={styles.heading}>सोशल मीडिया</h3>

          <div style={styles.socialIcons}>
            <a href="#" style={styles.link}>📘 Facebook</a>
            <a href="#" style={styles.link}>📷 Instagram</a>
            <a href="#" style={styles.link}>▶️ YouTube</a>
            <a href="#" style={styles.link}>💬 WhatsApp</a>
          </div>
        </div>

        {/* Government Links */}
        <div style={styles.footerSection}>
          <h3 style={styles.heading}>महत्वाच्या लिंक</h3>

          <a
            href="https://aaplesarkar.mahaonline.gov.in"
            target="_blank"
            rel="noreferrer"
            style={styles.link}
          >
            आपले सरकार
          </a>

          <a
            href="https://www.india.gov.in"
            target="_blank"
            rel="noreferrer"
            style={styles.link}
          >
            India Portal
          </a>

          <a
            href="https://rtionline.gov.in"
            target="_blank"
            rel="noreferrer"
            style={styles.link}
          >
            RTI Portal
          </a>

          <a
            href="https://egramswaraj.gov.in"
            target="_blank"
            rel="noreferrer"
            style={styles.link}
          >
            eGramSwaraj
          </a>
        </div>

      </div>

      <div style={styles.footerBottom}>
        © 2025 ग्रामपंचायत भालेवाडी | सर्व हक्क राखीव
      </div>
    </footer>
  );
};

export default Footer;